import {Stack, Text} from "@mantine/core";
import classes from "./Footer.module.css";
import {useTranslation} from "react-i18next";
type FooterProps = {
    variant: "detailed" | "simple";
};

const Footer = ({variant}: FooterProps) => {
    const {t} = useTranslation();
    return (
        <Stack /* m="auto"  */ gap="sm" w="100%" className={classes.footer}>
            {variant === "detailed" ? (
                <>
                    {null}
                    {/* <Text fz="xs" c="gray.6" mt="xl">
                        Dette er en KI assistent fra DIBKunnskap. Du kan stille
                        spørsmål om regnskap, revisjon og mer.
                    </Text>
                    <Text fz="xs" c="gray.6" mb="md">
                        Denne tjenesten vil kontinuerlig forbedres, og vi setter
                        pris på dine{" "}
                        <a
                            className={classes.link}
                            href="mailto:kontakt@dibkunnskap.no"
                        >
                            tilbakemeldinger
                        </a>
                        .
                    </Text> */}
                </>
            ) : (
                <Text className={classes.footerText}>
                    {t("common.disclaimer")}
                </Text>
            )}
        </Stack>
    );
};

export default Footer;
